import { IOnInit, ITimeoutService } from "angular";
import { Property, UserProperty } from "../../model/Property";
import { chunk } from "lodash";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import { UserProfile } from "../../../application/UserProfile";

export class UserPropertyComponentController implements IOnInit {
  static $inject = [ServerUtilityName, "$timeout"];

  // bindings start
  properties!: Property[];
  userProperties!: UserProperty[];
  user!: UserProfile;
  // bindings end

  chunkedProperties: Property[][] = [];

  constructor(
    private readonly serverUtility: ServerUtility,
    private readonly $timeout: ITimeoutService
  ) {}

  $onInit() {
    this.chunkedProperties = chunk(this.properties, 4);

    this.$timeout(0).then(() => {
      this.properties.forEach(
        (p) =>
          (p.UserProperty = !!this.userProperties.find(
            (up) => up.PropertyId === p.Id
          ))
      );
    });
  }

  userPropertyChanged(property: Property, userProperty: boolean) {
    this.serverUtility.sendApiRequest({
      method: userProperty ? "POST" : "DELETE",
      url: `/api/user/${this.user.UserAuthId}/properties`,
      data: {
        PropertyId: property.Id,
      },
    });
  }
}
